import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import AgentInfoService from "../../services/Agent/AgentInfoService";
import CardCreator from "../../components/CardCreator";
import UserSessionService from "../../services/UserSessionService";
import AgentCategoryService from "../../services/Agent/AgentCategoryService";
import ToastHelper from "../../utils/ToastHelper";
import "../../scss/Home.css";
import OutboundTransactionCommissionSummaryService
    from "../../services/finance/OutboundTransactionCommissionSummaryService";
import {Image} from "react-bootstrap";
import AgentService from "../../services/Agent/AgentService";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import ComplianceDataTable from "../../components/ComplianceDataTable";

class Home extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Dashboard");

        let userId = UserSessionService.getUser().user.id;
        let agentName = UserSessionService.getUser().user.firstName + ' ' + UserSessionService.getUser().user.lastName;

        this.state = {
            userId: userId,
            agentName: agentName,
            render: false,
            agentInfo: {},
            previousMonthTransactionInfo: {},
            agentCategories: [],
            showComplianceModal: false
        }
    }

    componentDidMount() {
        this.props.history.replace("");

        let promiseArr = [];

        promiseArr.push(AgentInfoService.retrieveAgentInfo(this.state.userId));
        promiseArr.push(AgentInfoService.retrieveAgentInfoForTheMonth(this.state.userId, this.getPreviousMonth()));
        promiseArr.push(AgentCategoryService.retrieveAllAgentCategories());
        promiseArr.push(OutboundTransactionCommissionSummaryService.retrieve(this.state.userId));
        promiseArr.push(AgentService.getCompliance(this.state.userId));

        Promise.all(promiseArr).then(responseArray => {

            let newState = {};

            newState.render = true;

            if (responseArray[0].errors) {
                ToastHelper.formatError(responseArray[0].message);
            } else {
                newState.agentInfo = responseArray[0];
            }

            if (responseArray[1].errors) {
                ToastHelper.formatError(responseArray[1].message);
            } else {
                newState.previousMonthTransactionInfo = responseArray[1];
            }

            if (responseArray[2].errors) {
                ToastHelper.formatError(responseArray[2].message);
            } else {
                newState.agentCategories = responseArray[2];
            }

            if (responseArray[3].errors) {
                ToastHelper.formatError(responseArray[3].message);
            } else {
                newState.commissionSummaryData = responseArray[3].body;
            }

            if (responseArray[4].complianceChecks) {
                newState.compliance = responseArray[4];
                newState.showComplianceModal = !responseArray[4].compliant;
            }

            this.setState({
                ...newState,
                loading: false
            })
        });
    }

    getPreviousMonth(newDate = new Date()) {
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1; // month indexes from zero
        let year = newDate.getFullYear();
        let separator = "-"

        if (month === 1) {
            year -= 1; // go back a year
            month = 12; // set month to December
        } else {
            month -= 1; // go back to previous month
        }
        return year + separator + (month < 10 ? "0" : "") + month + separator + (date < 10 ? "0" : "") + date;
    }

    render() {
        return <Fragment>

            <br/>

            <div className={"welcome_greeting_text"}>
                <span>Hi {this.state.agentName}</span>
            </div>

            {this.state.render &&
                <div className={"mainContent"}>
                    <CardCreator agentInfo={this.state.agentInfo}/>
                </div>
            }
            {this.state.render &&
                <Image className={"BackgroundImage"}
                       src={"/RSAgentPortalBackgroundImages/RS_Agent_Portal_Background_Images_copy_01.svg"}/>
            }
            {this.state.showComplianceModal && this.showComplianceModal()}
        </Fragment>

    }

    showComplianceModal() {
        return <Fragment>
            <Modal isOpen={this.state.showComplianceModal}
                   className={'modal-danger modal-md'}>
                <ModalHeader  className={'modal-header'}
                    toggle={() => this.setState({showComplianceModal: !this.state.showComplianceModal})}>Compliance Notice</ModalHeader>
                <ModalBody>
                     You might experience access restrictions due to missing compliance requirements, please see details below.
                     <ComplianceDataTable tableData={this.state.compliance.complianceChecks}/>
                    <br/>
                    For more information please see <span style={{fontWeight: "bold"}}>Agent Portal - Self Service</span> on the Announcements page.
                </ModalBody>
            </Modal>
        </Fragment>
    }

}

export default withRouter(Home);